import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {GroupTypes} from '@carm/_core/access-control-mgt/models/acl.model';
import { BusinessSelectorModalComponent } from '@carm/shared/components/business-selector-modal/business-selector-modal.component';
import {MDCMenu} from '@material/menu';
import { TranslateService } from '@ngx-translate/core';
import { ICompanyProgram } from '../models/menu-program.model';
import { CarmResources, RoleTypes } from '@carm/_core/access-control-mgt/models';
import { combineLatest } from 'rxjs';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { distinctUntilChanged, take, takeUntil } from 'rxjs/operators';
import { MenuService } from '../services/menu.service';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { AccessUserService } from '@carm/_core/access-control-mgt/services';
import { PublicHeaderService } from '../../public-header.service';
import { BaseComponent } from '@carm/_utils/base.component';
import { NotificationService } from '@carm/_core/notification-mgt/facade/notifcation.service';
import { ProgramFacadeService } from '@carm/_core/program-account-profile/services/program-facade.service';

@Component({
  selector: 'carm-main-header-program-menu-view',
  templateUrl: './main-header-program-menu-view.component.html',
  styleUrls: ['./main-header-program-menu-view.component.scss'],
})
export class MainHeaderProgramMenuViewComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('menu', { static: false }) menuRef: ElementRef;

  menu: MDCMenu;

  currentNativeBn9: string;

  groupType = GroupTypes;
  carmResource = CarmResources;
  public canSeeMenu = false;
  public programMenu: ICompanyProgram;
  public menuOpen: boolean;

  constructor(
    private matDialog: MatDialog,
    private translateService: TranslateService,
    private carmRouter: CarmRouter,
    private menuService: MenuService,
    private userService: UserService,
    private accessUserService: AccessUserService,
    private publicHeaderService: PublicHeaderService,
    private notificationService: NotificationService,
    private programFacadeService: ProgramFacadeService,
  ) {
    super();
  }

  ngOnInit() {
    this.publicHeaderService?.showProgramToggler
    .pipe(takeUntil(this.destroy$))
    .subscribe(showToggler => {
      if (showToggler) {
        this.buildProgramMenu();
      }
    });
  }

  buildProgramMenu() {
    combineLatest([
      this.carmRouter.bn9$,
      this.carmRouter.bn15$,
      this.carmRouter.nativeBn9$,
      this.userService.getUserRoles(),
      this.programFacadeService.getInactivePrograms()
    ])
    .pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged()
    )
    .subscribe(([bn9, bn15, nativeBn9, userRolesResponse, inactiveProgramList]) => { // if native-bn9 or bn15 change in URL, reload menu.

      this.canSeeMenu = userRolesResponse?.lastUsedRole?.roleType != RoleTypes.Orphan;

       this.programMenu = null;

       if(!userRolesResponse){ // logged out
         return;
       }

       //console.log(`URL STATE: nativeBn9: ${nativeBn9} bn9: ${bn9} bn15: ${bn15}`);
       //console.log('NGRX STATE: ', userRolesResponse.lastUsedRole?.program);

      if(nativeBn9 && userRolesResponse.business?.uid !== nativeBn9){
        console.log('url nativeBn9 does not match user nativeBn9');
        //return this.carmRouter.carmNavigate([RoutesConst.error404])
      }

      if(userRolesResponse.lastUsedRole?.program.companyUid ===  bn9){

        if(bn15 && userRolesResponse.lastUsedRole?.program.uid !== bn15){
          this.accessUserService.setLastUsedProgram(bn15).pipe(takeUntil(this.destroy$), take(1)).subscribe(x => {

            this.accessUserService.getUserRoles().pipe(takeUntil(this.destroy$)).subscribe(_ => {
              //so ngrx userService subscribers are notified.
            })
          //}, err => this.carmRouter.carmNavigate([RoutesConst.error404]));
          });
        }

        this.userService.getUserRoles().pipe(takeUntil(this.destroy$), take(1)).subscribe(x => {
          this.programMenu = this.menuService.buildProgramMenu(x, bn9, bn15);
        });

      }else{
        //console.log('NO BN MATCH');

        if(bn9){
          this.accessUserService.setLastUsedBusiness(bn9).pipe(takeUntil(this.destroy$)).subscribe(ur => {
            this.programMenu = this.menuService.buildProgramMenu(ur.role, bn9, bn15);
          //}, err => this.carmRouter.carmNavigate([RoutesConst.error404]));
          });
        }else{
          this.programMenu = null;
        }
      }

      this.programMenu?.programs?.forEach(program => {
            program.inactive  = inactiveProgramList.includes(program.programUid);
      });
    });
  }

  toggleMenu() {
    if (!this.menu && this.menuRef?.nativeElement) {
      this.menu = new MDCMenu(this.menuRef.nativeElement);
    }
    this.menu.open = !this.menuOpen;
    this.menuOpen = this.menu.open;
  }

  openBusinessSelector() {
    const businessSelector: MatDialogRef<BusinessSelectorModalComponent> = this.matDialog.open(BusinessSelectorModalComponent, {
      width: '800px',
      data: {
        title: this.translateService.instant('business_selector.title'),
        currentBusinessId: this.carmRouter.bn9
      },
    });
    businessSelector.componentInstance.companyUidSelected.subscribe((company) => {
      businessSelector.close();

      this.accessUserService.setLastUsedBusiness(company.uid).pipe(takeUntil(this.destroy$)).subscribe(ur => {

        //this.userService.updateRoles(ur);

        const firstProgram = ur.role.roles.filter(r => r.program.companyUid === company.uid).sortRoleByProgramRM()[0];

        this.carmRouter.carmNavigate([
          RoutesConst.Private,
          RoutesConst.NativeBusiness_Rel,
          ur.role.business.uid,
          RoutesConst.Program_Rel,
          firstProgram.program.uid,
          RoutesConst.Dashboard_Rel]).then(n => {
            window.location.reload();
          });

      })
    });
  }

  ngAfterViewInit() {
    if(this.menuRef?.nativeElement) { // null if no access
     this.menu = new MDCMenu(this.menuRef.nativeElement);
    }
  }

  onProgramSelect(programUid: string) {
      this.accessUserService.changeCurrentProgramByUid({ businessId: this.carmRouter.bn9, programId: programUid}).pipe(takeUntil(this.destroy$)).subscribe(() => {
        // fire and forget
      });

      if (this.programMenu.programUid !==  programUid){
        //Reloading page notifications
        this.notificationService.clearPageNotification();
      }
      this.toggleMenu()
      return this.carmRouter.carmNavigate([
        RoutesConst.Private,
        RoutesConst.NativeBusiness_Rel,
        this.carmRouter.nativeBn9,
        RoutesConst.Program_Rel,
        programUid,
        RoutesConst.Dashboard_Rel]);

  }
}
